module.exports = __webpack_public_path__ + "media/fodlinkedin.6bafc8df.mp4";